import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ptBR } from "@mui/x-data-grid/locales/ptBR";
import React, { ReactNode, useEffect, useState } from "react";

import ThemeSplash from "./components/common/effects/ThemeSplash";
import ThemeTransition from "./components/common/transitions/ThemeTransition";
import { convertToTheme, LightThemeOptions } from "./index";
import { ThemeContext } from "./ThemeContext";

type ThemeProviderProps = {
  children: ReactNode;
};

export const ThemeProviderWrapper: React.FC<ThemeProviderProps> = ({
  children,
}) => {
  // Forçar sempre tema claro (branco) para o projeto de totem
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const isTransitioning = false; // Sempre false - sem transições no totem
  const [showSplash, setShowSplash] = useState(false);

  const toggleTheme = () => {
    // Desabilitado - sempre manter tema claro
    // setIsTransitioning(true)
    // setShowSplash(true)

    // Mantém sempre o tema claro
    console.log(
      "Toggle tema desabilitado - sempre usando tema claro para totem",
    );
  };

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  useEffect(() => {
    // Comentado - não mais reativo ao tema do sistema
    // const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    // const handleThemeChange = (e: MediaQueryListEvent) => {
    //   setDarkMode(e.matches)
    // }

    // mediaQuery.addEventListener('change', handleThemeChange)

    // return () => {
    //   mediaQuery.removeEventListener('change', handleThemeChange)
    // }

    // Garantir que sempre inicie com tema claro
    setDarkMode(false);
  }, []);

  // Sempre usar tema light (branco)
  const selectedTheme = convertToTheme(LightThemeOptions);

  const themeWithLocale = createTheme(selectedTheme, ptBR);
  return (
    <ThemeContext.Provider value={{ theme: selectedTheme, toggleTheme }}>
      <ThemeProvider theme={themeWithLocale}>
        <Box
          sx={{
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            opacity: isTransitioning ? 0.95 : 1,
            "& *": {
              transition:
                "background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
            },
          }}
        >
          {children}
          <ThemeTransition
            isTransitioning={isTransitioning}
            isDarkMode={darkMode}
          />
          <ThemeSplash
            show={showSplash}
            isDarkMode={darkMode}
            onComplete={handleSplashComplete}
          />
        </Box>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
